/* file generated by apps/theme/export-theme.ts */

export type TailwindThemeMapping = [
  property: string,
  tailwindVar: string,
  type: 'color' | 'px',
]

export const tailwindThemeMappings: TailwindThemeMapping[] = [
  ['accent', '--color-th_accent', 'color'],
  ['focus', '--color-th_focus', 'color'],
  ['link', '--color-th_link', 'color'],
  ['separator', '--color-th_separator', 'color'],
  ['radiusSmall', '--radius-th_small', 'px'],
  ['radiusMedium', '--radius-th_medium', 'px'],
  ['radiusLarge', '--radius-th_large', 'px'],
  ['baseBackground', '--background-color-th_base', 'color'],
  ['baseAltBackground', '--background-color-th_base-alt', 'color'],
  ['basePlaneBackground', '--background-color-th_base-plane', 'color'],
  ['baseBorder', '--border-color-th_base', 'color'],
  ['baseContent', '--text-color-th_base', 'color'],
  ['baseContentSecondary', '--text-color-th_base-secondary', 'color'],
  ['baseContentTertiary', '--text-color-th_base-tertiary', 'color'],
  ['baseContentPositive', '--text-color-th_base-positive', 'color'],
  ['baseContentNegative', '--text-color-th_base-negative', 'color'],
  ['baseContentWarning', '--text-color-th_base-warning', 'color'],
  ['baseHoveredBackground', '--background-color-th_base-hovered', 'color'],
  ['frameBackground', '--background-color-th_frame', 'color'],
  ['frameContent', '--text-color-th_frame', 'color'],
  ['frameBorder', '--border-color-th_frame', 'color'],
  ['frameRadius', '--radius-th_frame', 'px'],
  ['badgeBackground', '--background-color-th_badge', 'color'],
  ['badgeContent', '--text-color-th_badge', 'color'],
  ['badgeStrongBackground', '--background-color-th_badge-strong', 'color'],
  ['badgeStrongContent', '--text-color-th_badge-strong', 'color'],
  ['badgeInfoBackground', '--background-color-th_badge-info', 'color'],
  ['badgeInfoContent', '--text-color-th_badge-info', 'color'],
  ['badgeNegativeBackground', '--background-color-th_badge-negative', 'color'],
  ['badgeNegativeContent', '--text-color-th_badge-negative', 'color'],
  ['badgePositiveBackground', '--background-color-th_badge-positive', 'color'],
  ['badgePositiveContent', '--text-color-th_badge-positive', 'color'],
  ['badgeWarningBackground', '--background-color-th_badge-warning', 'color'],
  ['badgeWarningContent', '--text-color-th_badge-warning', 'color'],
  ['primaryBackground', '--background-color-th_primary', 'color'],
  ['primaryBorder', '--border-color-th_primary', 'color'],
  ['primaryContent', '--text-color-th_primary', 'color'],
  [
    'primaryHoveredBackground',
    '--background-color-th_primary-hovered',
    'color',
  ],
  ['primaryHoveredBorder', '--border-color-th_primary-hovered', 'color'],
  ['secondaryBackground', '--background-color-th_secondary', 'color'],
  ['secondaryBorder', '--border-color-th_secondary', 'color'],
  ['secondaryContent', '--text-color-th_secondary', 'color'],
  [
    'secondaryHoveredBackground',
    '--background-color-th_secondary-hovered',
    'color',
  ],
  ['secondaryHoveredBorder', '--border-color-th_secondary-hovered', 'color'],
  ['distinctBackground', '--background-color-th_distinct', 'color'],
  ['distinctBorder', '--border-color-th_distinct', 'color'],
  ['distinctContent', '--text-color-th_distinct', 'color'],
  ['disabledBackground', '--background-color-th_disabled', 'color'],
  ['disabledBorder', '--border-color-th_disabled', 'color'],
  ['disabledContent', '--text-color-th_disabled', 'color'],
  ['negativeBackground', '--background-color-th_negative', 'color'],
  ['negativeContent', '--text-color-th_negative', 'color'],
  ['negativeBorder', '--border-color-th_negative', 'color'],
  [
    'negativeSecondaryBackground',
    '--background-color-th_negative-secondary',
    'color',
  ],
  ['negativeSecondaryContent', '--text-color-th_negative-secondary', 'color'],
  ['negativeSecondaryBorder', '--border-color-th_negative-secondary', 'color'],
  ['positiveBackground', '--background-color-th_positive', 'color'],
  ['positiveContent', '--text-color-th_positive', 'color'],
  ['positiveBorder', '--border-color-th_positive', 'color'],
  ['strongBackground', '--background-color-th_strong', 'color'],
  ['strongContent', '--text-color-th_strong', 'color'],
  ['strongBorder', '--border-color-th_strong', 'color'],
  ['warningBackground', '--background-color-th_warning', 'color'],
  ['warningContent', '--text-color-th_warning', 'color'],
  ['warningBorder', '--border-color-th_warning', 'color'],
  ['warningStrongBackground', '--background-color-th_warning-strong', 'color'],
  ['warningStrongContent', '--text-color-th_warning-strong', 'color'],
  ['warningStrongBorder', '--border-color-th_warning-strong', 'color'],
  ['fieldBackground', '--background-color-th_field', 'color'],
  ['fieldBorder', '--border-color-th_field', 'color'],
  ['fieldContent', '--text-color-th_field', 'color'],
  ['fieldContentSecondary', '--text-color-th_field-secondary', 'color'],
  ['fieldContentTertiary', '--text-color-th_field-tertiary', 'color'],
  ['fieldErrorBorder', '--border-color-th_field-error', 'color'],
  ['fieldNegativeBorder', '--border-color-th_field-negative', 'color'],
  ['fieldNegativeBackground', '--background-color-th_field-negative', 'color'],
  ['fieldPositiveBorder', '--border-color-th_field-positive', 'color'],
  ['fieldPositiveBackground', '--background-color-th_field-positive', 'color'],
  ['fieldFocusedBackground', '--background-color-th_field-focused', 'color'],
  ['fieldFocusedContent', '--text-color-th_field-focused', 'color'],
]
